import { takeLatest, call, put, all } from 'redux-saga/effects';
import Tracking from '~/config/tracking';
import * as api from '~/services/api';
import { transFormErrorResponse } from '../utils';
import * as actions from './actions';

function showToast(err) {
  // TODO: PARCHE!! Condición provisional que ha de ser eliminada. Consultar a Juan Martos
  if (err.response.status !== 404) {
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* getMatches({ payload: { query = '' } }) {
  try {
    const { data } = yield call(api.getMatches, query);
    yield put(
      actions.getMatchesSuccess({
        dates: data,
      })
    );
  } catch (err) {
    yield put(actions.getMatchesFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}
export function* getSelectedMatch({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getMatch, matchId);
    yield put(actions.getSelectedMatchSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}
export function* getSelectedMatchStatus({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getMatchStatus, matchId);
    yield put(actions.getSelectedMatchStatusSuccess(data.inGame));
  } catch (err) {
    yield put(actions.getSelectedMatchStatusFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}
export function* getSelectedMatchScore({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getMatchScore, matchId);
    yield put(actions.getSelectedMatchScoreSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchScoreFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}
export function* getSquads({ payload: { localId, visitorId } }) {
  try {
    const localTeamData = yield call(api.getSquad, localId);
    const visitorTeamData = yield call(api.getSquad, visitorId);
    yield put(
      actions.getSquadsSuccess({
        localSquad: localTeamData.data,
        visitorSquad: visitorTeamData.data,
      })
    );
  } catch (err) {
    yield put(actions.getSquadsFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}
export function* getSelectedMatchReferees({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getReferees, matchId);
    yield put(actions.getSelectedMatchRefereesSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchRefereesFailure());
    showToast(err);
  }
}

export function* getSelectedMatchRefereeAssistants({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getRefereeAssistants, matchId);

    const refereeAvailableRoles = [
      'var-referee',
      'avar-referee',
      'assistant-referee-1',
      'assistant-referee-2',
      'fourth-referee',
    ];

    const availableReferees = refereeAvailableRoles
      .map(
        role =>
          data.referees && data.referees.find(referee => referee.role === role)
      )
      .filter(hasReferee => hasReferee);

    const availableRefereeAssistants = { ...data, referees: availableReferees };

    yield put(
      actions.getSelectedMatchRefereeAssistantsSuccess(
        availableRefereeAssistants
      )
    );
  } catch (err) {
    yield put(actions.getSelectedMatchRefereeAssistantsFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}
export function* getSelectedMatchKits({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getKits, matchId);
    yield put(actions.getSelectedMatchKitsSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchKitsFailure());
    showToast(err);
  }
}
export function* getSelectedMatchGrassStatus({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getGrassStatus, matchId);
    yield put(actions.getSelectedMatchGrassStatusSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchGrassStatusFailure());
    showToast(err);
  }
}
export function* getSelectedMatchLineup({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getLineup, matchId);
    yield put(actions.getSelectedMatchLineupSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchLineupFailure());
    showToast(err);
  }
}

export function* getSelectedMatchActs({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getActs, matchId);
    yield put(actions.getSelectedMatchActsSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchActsFailure());
    showToast(err);
  }
}

export function* getSelectedMatchTeamStats({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getStats, matchId);
    yield put(actions.getSelectedMatchTeamStatsSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchTeamStatsFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* getSelectedMatchEvents({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getEvents, matchId);
    yield put(actions.getSelectedMatchEventsSuccess(data));
  } catch (err) {
    const hasEvents = err?.response?.status !== 404;
    if (hasEvents) {
      yield put(actions.getSelectedMatchEventsFailure());
      showToast(err);
    }
  }
}

export function* getSelectedMatchDirectStats({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getDirectStats, matchId);
    yield put(actions.getSelectedMatchDirectStatsSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchDirectStatsFailure());
    showToast(err);
  }
}

export function* getSelectedMatchPublicFiles({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getPublicFiles, matchId);
    yield put(actions.getSelectedMatchPublicFilesSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchPublicFilesFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* getSelectedMatchPrivateFiles({ payload: { matchId } }) {
  try {
    const { data } = yield call(api.getPrivateFiles, matchId);
    yield put(actions.getSelectedMatchPrivateFilesSuccess(data));
  } catch (err) {
    yield put(actions.getSelectedMatchPrivateFilesFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export default all([
  takeLatest(actions.Types.GET_MATCHES_REQUEST, getMatches),
  takeLatest(actions.Types.GET_SQUADS_REQUEST, getSquads),
  takeLatest(actions.Types.GET_SELECTED_MATCH_REQUEST, getSelectedMatch),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_STATUS_REQUEST,
    getSelectedMatchStatus
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_SCORE_REQUEST,
    getSelectedMatchScore
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_REFEREES_REQUEST,
    getSelectedMatchReferees
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_REFEREE_ASSISTANTS_REQUEST,
    getSelectedMatchRefereeAssistants
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_KITS_REQUEST,
    getSelectedMatchKits
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_GRASS_STATUS_REQUEST,
    getSelectedMatchGrassStatus
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_LINEUP_REQUEST,
    getSelectedMatchLineup
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_ACTS_REQUEST,
    getSelectedMatchActs
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_TEAM_STATS_REQUEST,
    getSelectedMatchTeamStats
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_EVENTS_REQUEST,
    getSelectedMatchEvents
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_DIRECT_STATS_REQUEST,
    getSelectedMatchDirectStats
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_PUBLIC_FILES_REQUEST,
    getSelectedMatchPublicFiles
  ),
  takeLatest(
    actions.Types.GET_SELECTED_MATCH_PRIVATE_FILES_REQUEST,
    getSelectedMatchPrivateFiles
  ),
]);
